export default (state, action) => {
  const newAddress = Object.assign(state.address, action.payload);
  return {
    ...state,
    address: newAddress,
  };
};
